import { useState, useMemo, useEffect } from "react";
import { BlogPreview } from "../components/BlogPreview/BlogPreview";
import ListFilter from "../components/ListFilter/ListFilter";
import { useLocation } from "react-router-dom";

export const PostListLayout = ({ title, posts }) => {
    const [sortOrder, setSortOrder] = useState("newest");
    const [searchInput, setSearchInput] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const location = useLocation();

    useEffect(() => {
        const savedScrollPos = sessionStorage.getItem("listScrollPos");
        if (savedScrollPos) {
            requestAnimationFrame(() => {
                window.scrollTo(0, parseInt(savedScrollPos));
                sessionStorage.removeItem("listScrollPos");
            });
        }
    }, [location.pathname]);

    const saveScrollPosition = () => {
        sessionStorage.setItem("listScrollPos", window.scrollY);
    };

    useEffect(() => {
        if (searchInput === "") {
            setSearchQuery(""); // Reset search filter when input is empty
        }
    }, [searchInput]);

    // Function to handle search
    const handleSearch = () => {
        setSearchQuery(searchInput);
    };

    // Function to handle key press
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    const sortedPosts = useMemo(() => {
        return [...posts].sort((a, b) => {
            let dateA = new Date(a.date);
            let dateB = new Date(b.date);
            return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
        });
    }, [sortOrder, posts]);

    const filteredPosts = useMemo(() => {
        return sortedPosts.filter((post) => {
            const matchesSearch =
                post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                post.date.toLowerCase().includes(searchQuery.toLowerCase());

            return matchesSearch;
        });
    }, [sortedPosts, searchQuery]);

    return (
        <div className="container">
            <h1 style={{ margin: "10px" }}>{title}</h1>
            <div className="innerContainer">
                <ListFilter
                    searchInput={searchInput}
                    setSearchInput={setSearchInput}
                    handleKeyPress={handleKeyPress}
                    handleSearch={handleSearch}
                    sortOrder={sortOrder}
                    setSortOrder={setSortOrder}
                />
                <div className="previewList">
                    {filteredPosts.length === 0 ? (
                        <p>No posts found.</p>
                    ) : (
                        filteredPosts.map((post) => (
                            <BlogPreview key={post._id} post={post} onClick={saveScrollPosition} />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};
